enum DropdownItemRole {
  Button,
  Divider,
}

export default DropdownItemRole;
